import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as businessReducer from "containers/Business/BusinessReducer";
import * as wizardReducer from "containers/Wizard/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";

import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";

import MadLibsBox from "components/Business/ModelBox/MadLibsBox";
import NextMadLibsBox from "components/Next/ModelBox/MadLibsBox";

class ModelBoxContainer extends React.PureComponent {
  render() {
    return this.props.isNext ? <NextMadLibsBox {...this.props} /> : <MadLibsBox {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps.id;

  const retId = ownProps.isEditBlueprint
    ? ownProps.editBlueprintId
    : ownProps.innerRunId !== undefined
      ? ownProps.innerRunId
      : id;

  return {
    updateTrueAction: (trueAction) => dispatch(setupReducer.updateTrueAction(retId, trueAction)),
    updateFalseAction: (falseAction) => dispatch(setupReducer.updateFalseAction(retId, falseAction)),
    updateOutcomeLabel: (outcomeLabel) => dispatch(setupReducer.updateOutcomeLabel(retId, outcomeLabel)),
    updateTransactionLabel: (transactionLabel) =>
      dispatch(setupReducer.updateTransactionLabel(retId, transactionLabel)),
    updateNotPursuedTransactionLabel: (notPursuedTransactionLabel) =>
      dispatch(setupReducer.updateNotPursuedTransactionLabel(retId, notPursuedTransactionLabel)),
    updateAdvancedRevenueLabel: (advRevenueLabel) =>
      dispatch(setupReducer.updateAdvancedRevenueLabel(retId, advRevenueLabel)),
    updateAdvancedCostLabel: (label) => dispatch(setupReducer.updateAdvancedCostLabel(retId, label)),
    updateNetImpactLabel: (label) => dispatch(setupReducer.updateNetImpactLabel(retId, label)),
    updateTruePositiveLabel: (truePositiveLabel) =>
      dispatch(setupReducer.updateTruePositiveLabel(retId, truePositiveLabel)),
    updateUnitType: (unitType) => dispatch(setupReducer.updateUnitType(retId, unitType)),

    updateMadLibs: (key, value) => dispatch(setupReducer.updateMadLibs(retId, key, value)),

    updateCurrentStep: (stepId) => dispatch(businessReducer.updateCurrentStep(id, stepId)),

    trainAI: (options) =>
      dispatch(businessReducer.startModelRun(ownProps.id, ownProps.runId, ownProps.blueprintId, options)),
    retrainRun: () => dispatch(projectReducer.retrainRun(id))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;

  const isEditBlueprint = unifiedProjectReducer.getIsEditBlueprint(state, id);

  const editBlueprintId = unifiedProjectReducer.getEditBlueprintRunId(state, id);

  const innerRunId = projectReducer.getInnerId(state, id);

  const runId = isEditBlueprint && editBlueprintId !== undefined ? editBlueprintId : innerRunId ? innerRunId : id;

  const type = wizardReducer.STEP_TYPE.ACADEMIC_CHOOSE_DATASET.id;
  const wStep =
    Object.keys(wizardReducer.STEP_TYPE).filter((s) => wizardReducer.STEP_TYPE[s].id === type).length > 0
      ? Object.keys(wizardReducer.STEP_TYPE)
          .filter((s) => wizardReducer.STEP_TYPE[s].id === type)
          .map((s) => wizardReducer.STEP_TYPE[s])[0]
      : undefined;

  return {
    id: id,
    runId: runId,
    innerRunId: innerRunId,
    isEditBlueprint: isEditBlueprint,
    editBlueprintId: editBlueprintId,
    blueprintId: businessReducer.getBlueprintId(state, id),
    setup: setupReducer.getSetup(state, runId),

    isContinuous: setupReducer.getIsContinuous(state, runId),
    setupLabels: setupReducer.getSetupLabels(state, runId),

    transactionLabel: setupReducer.getTransactionLabel(state, runId),
    outcomeLabel: setupReducer.getOutcomeLabel(state, runId),
    notPursuedTransactionLabel: setupReducer.getNotPursuedTransactionLabel(state, runId),
    trueAction: setupReducer.getTrueAction(state, runId),
    falseAction: setupReducer.getFalseAction(state, runId),
    unitType: setupReducer.getUnitType(state, runId),

    costLabel: setupReducer.getAdvancedCostLabel(state, runId),
    revenueLabel: setupReducer.getAdvancedRevenueLabel(state, runId),
    profitLabel: setupReducer.getNetImpactLabel(state, runId),
    truePositiveLabel: setupReducer.getTruePositiveLabel(state, runId),

    madLibs: setupReducer.getMadLibs(state, runId),

    outcome: setupReducer.getOutcomeFromDataset(state, runId),

    project: projectReducer.getProject(state, id),

    isNextEnabled:
      wStep === undefined || wStep.isEnabled === undefined ? true : wStep.isEnabled(state, { ...ownProps, id: "new" }),

    isRetraining: projectReducer.getIsRetraining(state, id),
    hasSetupIgnoreChanged: innerRunId !== undefined ? setupReducer.getSetupIgnoreChanged(state, runId) : false
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ModelBoxContainer);
